module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp12_7042.772a41f1.png";